import { SignalsEmptyView } from "app/pages/sales-intelligence/common-components/SignalsEmptyView/SignalsEmptyView";
import SignalsManagementButtonContainer from "app/pages/sales-intelligence/sub-modules/signals/containers/SignalsManagementButton";

interface SignalsRestApiEmptyViewProps {
    onClick: VoidFunction;
}

export const SignalsRestApiEmptyView = ({ onClick }: SignalsRestApiEmptyViewProps) => {
    return (
        <SignalsEmptyView
            titleKey="si.management.integration.signals-rest-api.section.set-signals.empty.title"
            subtitleKey="si.management.integration.signals-rest-api.section.set-signals.empty.subtitle"
            data-automation="signals-rest-api-empty-view"
            actionButton={
                <SignalsManagementButtonContainer
                    emptyButtonText="si.management.integration.signals-rest-api.section.set-signals.create-first-signal"
                    onClick={onClick}
                />
            }
        />
    );
};
